import { useEffect, useRef, useState } from 'react';

const TubesCursor = ({
    initialColors = ["#f967fb", "#53bc28", "#6958d5"],
    lightColors = ["#83f36e", "#fe8a2e", "#ff008a", "#60aed5"],
    lightIntensity = 200,
    randomizeOnClick = true
}) => {
    const containerRef = useRef(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!containerRef.current) return;

        let isMounted = true;
        let cleanupFn = null;

        const init = async () => {
            try {
                // Create a unique ID for this instance
                const instanceId = `tubes-cursor-${Date.now()}`;
                const canvasId = `canvas-${instanceId}`;

                // Create canvas
                const canvas = document.createElement('canvas');
                canvas.id = canvasId;
                canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';

                if (containerRef.current) {
                    containerRef.current.appendChild(canvas);
                }

                // Load the script dynamically via import()
                const scriptUrl = 'https://cdn.jsdelivr.net/npm/threejs-components@0.0.19/build/cursors/tubes1.min.js';

                // Use dynamic import
                const module = await import(/* webpackIgnore: true */ scriptUrl);
                const TubesCursor = module.default;

                if (!isMounted) return;

                // Initialize TubesCursor
                const app = TubesCursor(canvas, {
                    tubes: {
                        colors: initialColors,
                        lights: {
                            intensity: lightIntensity,
                            colors: lightColors
                        }
                    }
                });

                // Handle click randomization
                const handleClick = () => {
                    if (!randomizeOnClick || !app.tubes) return;

                    const colors = Array.from({ length: 3 }, () =>
                        "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')
                    );
                    const lightsColors = Array.from({ length: 4 }, () =>
                        "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')
                    );

                    app.tubes.setColors(colors);
                    app.tubes.setLightsColors(lightsColors);
                };

                if (randomizeOnClick) {
                    document.body.addEventListener('click', handleClick);
                }

                // Cleanup function
                cleanupFn = () => {
                    if (randomizeOnClick) {
                        document.body.removeEventListener('click', handleClick);
                    }

                    // Dispose Three.js resources
                    if (app && app.dispose) {
                        app.dispose();
                    }

                    // Remove canvas
                    if (canvas && canvas.parentNode) {
                        canvas.parentNode.removeChild(canvas);
                    }
                };

            } catch (err) {
                console.error('TubesCursor error:', err);
                setError(err.message);
            }
        };

        init();

        return () => {
            isMounted = false;
            if (cleanupFn) {
                cleanupFn();
            }
        };
    }, [initialColors, lightColors, lightIntensity, randomizeOnClick]);

    return (
        <div ref={containerRef} className="relative w-full h-full bg-black">
            {error && (
                <div className="absolute inset-0 flex items-center justify-center text-white text-sm p-4">
                    <div className="text-center">
                        <p className="mb-2">Failed to load TubesCursor</p>
                        <p className="text-xs text-gray-400">{error}</p>
                        <p className="text-xs text-gray-500 mt-2">This component requires WebGL support</p>
                    </div>
                </div>
            )}
            {/* <div className="relative h-full flex flex-col items-center justify-center gap-2.5 pointer-events-none z-10">
                <h1
                    className="text-[80px] font-bold uppercase text-white m-0 p-0 leading-none select-none"
                    style={{ textShadow: '0 0 20px rgba(0, 0, 0, 1)' }}
                >
                    Tubes
                </h1>
                <h2
                    className="text-[60px] font-medium uppercase text-white m-0 p-0 leading-none select-none"
                    style={{ textShadow: '0 0 20px rgba(0, 0, 0, 1)' }}
                >
                    Cursor
                </h2>
                <p
                    className="text-white m-0 p-0 leading-none select-none"
                    style={{ textShadow: '0 0 20px rgba(0, 0, 0, 1)' }}
                >
                    WebGPU / WebGL
                </p>
            </div> */}
        </div>
    );
};

export default TubesCursor;
